/* Purelly · comportamento da página do Olio di Semi di Zucca (template product.zucca).
   Botões "Provalo senza rischi" → rolam até a oferta; contadores das estatísticas; carrossel das avaliações;
   acordeão dos benefícios; linha do tempo; carrossel das 5 ragioni; abas; contador "L'offerta termina tra". */
(function () {
  if (window.__plZucca) return;
  window.__plZucca = true;

  /* ---------- rolar até a oferta (widget do Kaching; senão o topo do produto) ---------- */
  function visivel(el) {
    if (!el || el.tagName === 'SCRIPT' || el.tagName === 'TEMPLATE') return false;
    if (!el.getClientRects || !el.getClientRects().length) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  // o cabeçalho do Dawn some ao descer e volta ao subir: como a rolagem até a oferta é para cima,
  // ele reaparece por cima do widget. Por isso desconta a altura dele mesmo quando está escondido.
  function alturaTopo() {
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group, .section-header, sticky-header, .header-wrapper').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (el.offsetHeight > 0 && el.offsetHeight < 260) h = Math.max(h, el.offsetHeight);
    });
    return h + 12;
  }
  function alvo() {
    var k = document.querySelectorAll('.kaching-bundles, [class*="kaching-bundles__"]');
    for (var i = 0; i < k.length; i++) { if (visivel(k[i])) return k[i]; }
    var f = ['#zc-acquista', 'product-form', '[id^="MainProduct-"]'];
    for (var j = 0; j < f.length; j++) { var e = document.querySelector(f[j]); if (visivel(e)) return e; }
    return null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href="#zc-acquista"]') : null;
    if (!a) return;
    var c = alvo();
    if (!c) return;
    e.preventDefault();
    var y = Math.max(0, c.getBoundingClientRect().top + window.pageYOffset - alturaTopo());
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* ---------- contadores das estatísticas ---------- */
  var nums = document.querySelectorAll('.zcs [data-zc-count]');
  function conta(el) {
    var fim = parseInt(el.getAttribute('data-zc-count'), 10) || 0, ini = null, dur = 1100;
    function passo(t) {
      if (ini === null) ini = t;
      var p = Math.min((t - ini) / dur, 1);
      el.textContent = Math.round(fim * (1 - Math.pow(1 - p, 3))) + '%';
      if (p < 1) requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);
  }
  if (nums.length && 'IntersectionObserver' in window) {
    var ioN = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { conta(e.target); ioN.unobserve(e.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (e) { ioN.observe(e); });
  }

  /* ---------- carrossel das avaliações ---------- */
  document.querySelectorAll('.zrv-sec').forEach(function (sec) {
    var pista = sec.querySelector('.zrv-cards');
    if (!pista) return;
    var cartoes = [].slice.call(sec.querySelectorAll('.zrv-card'));
    var botoes = [].slice.call(sec.querySelectorAll('.zrv-nav button'));
    function acender() {
      var g = pista.scrollLeft, d = g + pista.clientWidth;
      cartoes.forEach(function (c) {
        var a = c.offsetLeft - pista.offsetLeft, b = a + c.offsetWidth;
        c.classList.toggle('is-near', a >= g - 12 && b <= d + 12);
      });
      botoes.forEach(function (bt) {
        var s = +bt.getAttribute('data-zrv');
        bt.disabled = (s < 0 && g <= 2) || (s > 0 && g >= pista.scrollWidth - pista.clientWidth - 2);
      });
    }
    function passo() { return cartoes[0] ? cartoes[0].offsetWidth + 16 : 300; }
    botoes.forEach(function (bt) {
      bt.addEventListener('click', function () { pista.scrollBy({ left: passo() * (+bt.getAttribute('data-zrv')), behavior: 'smooth' }); });
    });
    var t = null;
    pista.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(acender, 70); }, { passive: true });
    window.addEventListener('resize', acender);
    requestAnimationFrame(acender);
  });

  /* ---------- acordeão dos benefícios (um aberto por coluna) ---------- */
  document.querySelectorAll('.zcbn-acc > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = b.parentElement, aberto = d.classList.contains('zcbn-open');
      d.parentElement.querySelectorAll('.zcbn-acc.zcbn-open').forEach(function (o) { if (o !== d) o.classList.remove('zcbn-open'); });
      d.classList.toggle('zcbn-open', !aberto);
      b.setAttribute('aria-expanded', String(!aberto));
    });
  });

  /* ---------- linha do tempo: os passos aparecem ao rolar ---------- */
  var tl = document.querySelector('.zcl');
  if (tl && 'IntersectionObserver' in window) {
    tl.classList.add('zcl-js');
    var ioT = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('zcl-on'); ioT.unobserve(e.target); } });
    }, { threshold: 0.25 });
    tl.querySelectorAll('.zcl-step').forEach(function (p) { ioT.observe(p); });
  }

  /* ---------- 5 ragioni ---------- */
  document.querySelectorAll('.zcr').forEach(function (sec) {
    var trilho = sec.querySelector('.zcr-rail');
    if (!trilho) return;
    var bts = [].slice.call(sec.querySelectorAll('.zcr-nav button'));
    function estado() {
      var g = trilho.scrollLeft;
      bts.forEach(function (b) {
        var s = +b.getAttribute('data-zcr');
        b.disabled = (s < 0 && g <= 2) || (s > 0 && g >= trilho.scrollWidth - trilho.clientWidth - 2);
      });
    }
    bts.forEach(function (b) {
      b.addEventListener('click', function () {
        var c = trilho.querySelector('.zcr-card');
        trilho.scrollBy({ left: (c ? c.offsetWidth + 20 : 356) * (+b.getAttribute('data-zcr')), behavior: 'smooth' });
      });
    });
    var t = null;
    trilho.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(estado, 70); }, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  });

  /* ---------- abas ---------- */
  document.querySelectorAll('.zcg').forEach(function (sec) {
    var bts = sec.querySelectorAll('.zcg-tabs button');
    bts.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-zcg');
        bts.forEach(function (o) { o.setAttribute('aria-selected', o === b ? 'true' : 'false'); });
        sec.querySelectorAll('.zcg-panel').forEach(function (p) {
          if (p.getAttribute('data-zcg-panel') === n) p.setAttribute('data-open', '1'); else p.removeAttribute('data-open');
        });
      });
    });
  });

  /* ---------- "L'offerta termina tra": conta até a meia-noite ---------- */
  var relogios = document.querySelectorAll('[data-zuc-timer]');
  if (relogios.length) {
    var dois = function (n) { return (n < 10 ? '0' : '') + n; };
    var tique = function () {
      var agora = new Date(), fim = new Date(agora);
      fim.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((fim - agora) / 1000));
      var txt = dois(Math.floor(s / 3600)) + ' : ' + dois(Math.floor(s % 3600 / 60)) + ' : ' + dois(s % 60);
      relogios.forEach(function (r) { r.textContent = txt; });
    };
    tique();
    setInterval(tique, 1000);
  }
})();
